// extracted by mini-css-extract-plugin
export default {"Preview":"Preview_Preview__hqz3S","element":"Preview_element__uvbK3"};